import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Logo } from "../components/app/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-zinc-950">
      <div className="w-full max-w-sm">
        <div className="mb-10"><Logo /></div>
        <h1 className="text-3xl font-semibold tracking-tight text-zinc-50 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
          Reset your password
        </h1>
        <p className="text-sm text-zinc-400 mb-8">We'll send you a reset link if the email is on file.</p>
        {done ? (
          <div className="rounded-lg border border-zinc-800 bg-zinc-900/60 p-4 text-sm text-zinc-300" data-testid="forgot-success">
            If that email exists, a reset link is on its way. (In Phase 1 the link is logged to the server console.)
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-zinc-400 mb-1.5">Email</label>
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-zinc-900 border border-zinc-800 rounded-lg px-3 py-2.5 text-sm text-zinc-100 focus:outline-none focus:ring-2 focus:ring-orange-600/50 focus:border-orange-600"
                data-testid="forgot-email-input"
              />
            </div>
            {error && <p className="text-sm text-red-400">{error}</p>}
            <button
              type="submit" disabled={submitting}
              className="w-full bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white font-medium px-4 py-2.5 rounded-lg text-sm transition-colors"
              data-testid="forgot-submit-btn"
            >
              {submitting ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <p className="mt-6 text-sm text-zinc-400 text-center">
          <Link to="/login" className="text-orange-500 hover:text-orange-400">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
